module.exports = __webpack_public_path__ + "static/media/ComingSoonWeb.a29c7201.png";